import request from '@/utils/request';
import configR from '@/configs.js';
const API = configR.envConfigs.PORTAL_API;
// 获取事务数量
export function getEventCount(data) {
  return data.request({
    url: `${data.serveUrl}v1/count/ttcCount`,
    method: "get",
    headerType: data.header
  });
}

// 我的待办
export function getTodoList(data) {
  return data.request({
    url: `${data.serveUrl}v1/transaction/myTodo`,
    method: "get",
    params: data.params,
    headerType: data.header
  });
}

// 办结事务
export function getDoneList(data) {
  return data.request({
    url: `${data.serveUrl}v1/transaction/myHandle`,
    method: "get",
    params: data.params,
    headerType: data.header
  });
}

// 我发起的
export function getInitiateUnfinishedList(data) {
  return data.request({
    url: `${data.serveUrl}v1/transaction/myApplyAll`,
    method: "get",
    params: data.params,
    headerType: data.header
  });
}

// 我的传阅 - 传阅给我的
export function getCirculateToMeList(data) {
  return data.request({
    url: `${data.serveUrl}v1/transaction/myTurnTo`,
    method: "get",
    params: data.params,
    headerType: data.header
  });
}

// 我的传阅 - 我传阅的
export function getCirculateMeToList(data) {
  return data.request({
    url: `${data.serveUrl}v1/transaction/myRead`,
    method: "get",
    params: data.params,
    headerType: data.header
  });
}

// 设为催办
export function urgeEvent(data) {
  return data.request({
    url: `${data.api}`,
    method: data.method,
    data: data.data,
    headerType: data.header
  });
}
// 我发起的撤回
export function reCallEvent(data) {
  return data.request({
    url: `${data.api}`,
    method: data.method,
    data: data.data,
    headerType: data.header
  });
}
// 事务搜索
export function saveTasks(param) {
  return request({
    url: `${API}v1/search/saveTasks`,
    method: "post",
    headerType: "portal",
    params:param


  });
}
